export const getSummaryChartOptions = (mode: string | null) => {
  const textColor = mode === "dark" ? "#f1f5f9" : "#1f2937";
  return {
    series: [],
    colors: [], // '#E74694', '#1C64F2', '#16BDCA', '#FDBA8C',
    chart: {
      height: "100%",
      type: "donut",
    },
    stroke: {
      colors: ["transparent"],
      lineCap: "",
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
              fontFamily: "Inter, sans-serif",
              offsetY: 20,
            },
            total: {
              showAlways: true,
              color: textColor,
              show: true,
              label: "Field Claimed",
              fontFamily: "Inter, sans-serif",
              fontSize: "1rem",
              formatter: function (w: { globals: { seriesTotals: any[] } }) {
                const sum = w.globals.seriesTotals.reduce((a, b) => {
                  return a + b;
                }, 0);
                return Number(sum).toLocaleString();
              },
            },
            value: {
              show: true,
              color: textColor,
              fontFamily: "Inter, sans-serif",
              offsetY: -20,
              fontSize: "1rem",
              formatter: function (value: string) {
                return value;
              },
            },
          },
          size: "80%",
        },
      },
    },
    grid: {
      padding: {
        top: -2,
      },
    },
    labels: ["Claimed Fields", "Unclaimed Fields"],
    dataLabels: {
      enabled: false,
    },
    legend: {
      position: "bottom",
      fontFamily: "Inter, sans-serif",
      fontSize: "14px",
      labels: {
        colors: textColor,
      },
    },
    yaxis: {
      labels: {
        formatter: function (value: string) {
          return Number(value).toLocaleString();
        },
      },
    },
    xaxis: {
      labels: {
        formatter: function (value: string) {
          return value;
        },
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
    },
  };
};

export const updateSummaryChartOptionsForTextMode = (mode: string | null) => {
  const textColor = mode === "dark" ? "#f1f5f9" : "#1f2937";
  return {
    legend: {
      labels: { colors: textColor },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            name: { color: textColor },
            total: { color: textColor },
            value: { color: textColor },
          },
        },
      },
    },
  };
};
